module.exports = __webpack_public_path__ + "static/media/uploadCanva.a7191d21.svg";